<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions" [responseCallback]="responseCallback"
    [pagerVisible]="true" [updateStatusType]="updateStatusType" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
    [rowClassRules]="rowClassRules">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="organization-settings-add-new-custom-field-button"
        class="secondary-button" (click)="addNewUser()" *ngIf="hasPermission" [disabled]="isDisabled()">
        <i class="fa fa-plus"></i>{{newUserBtn}}
    </button>
</ng-template>